import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

let AuthenticationUsageService = class AuthenticationUsageService {
    constructor(_storageService) {
        this._storageService = _storageService;
    }
    readAccountUsages(providerId, accountName) {
        const accountKey = `${providerId}-${accountName}-usages`;
        const storedUsages = this._storageService.get(accountKey, -1 );
        let usages = [];
        if (storedUsages) {
            try {
                usages = JSON.parse(storedUsages);
            }
            catch (e) {
            }
        }
        return usages;
    }
    removeAccountUsage(providerId, accountName) {
        const accountKey = `${providerId}-${accountName}-usages`;
        this._storageService.remove(accountKey, -1 );
    }
    addAccountUsage(providerId, accountName, extensionId, extensionName) {
        const accountKey = `${providerId}-${accountName}-usages`;
        const usages = this.readAccountUsages(providerId, accountName);
        const existingUsageIndex = usages.findIndex(usage => usage.extensionId === extensionId);
        if (existingUsageIndex > -1) {
            usages.splice(existingUsageIndex, 1, {
                extensionId,
                extensionName,
                lastUsed: Date.now()
            });
        }
        else {
            usages.push({
                extensionId,
                extensionName,
                lastUsed: Date.now()
            });
        }
        this._storageService.store(accountKey, JSON.stringify(usages), -1 , 1 );
    }
};
AuthenticationUsageService = ( __decorate([
    ( __param(0, IStorageService))
], AuthenticationUsageService));

export { AuthenticationUsageService };
